import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-net-navbarpage',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './net-navbarpage.component.html',
  styleUrls: ['./net-navbarpage.component.scss']
})
export class NetNavbarpageComponent implements OnInit {
  pathdata: any = {};
  menuSelected: any;
  membermenuflag: boolean = true;
  pendingCount: any;
  networkOwnerFlag: boolean = false;
  countrEmitter: Subscription;
  @Input()
  userDataInput: string;
  menus: any;
  commonVariables: any = {};
  currentRoute: string;
  isDefaultNetwork: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private util: UtilService,
    private router: Router,
    private SearchData: SearchData,
    private api: ApiService) {
    this.countrEmitter = this.SearchData.getCommonVariables().subscribe((res) => {
      this.pendingCount = res.pendingCount;
    });


    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.url;
        this.openSectionForUrl(event.url);
      }
    });
  }

  // Expand the Members section when the URL is its sub-page. Only ever opens;
  // it never forces the section closed, so navigating via the label does not
  // undo an arrow click.
  openSectionForUrl(url: string) {
    if (url.includes('/networkPage/inviteSent')) {
      this.membermenuflag = false;
    }
  }

  // Arrow click: flip the section open/closed and nothing else.
  toggleSubMenu(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.membermenuflag = !this.membermenuflag;
  }

  ngOnInit() {
    this.currentRoute = this.router.url;
    this.openSectionForUrl(this.currentRoute);
    this.route.queryParams.subscribe((res) => {
      this.pathdata = res;
      // if(this.userDataInput != undefined)
      // this.menus = this.userDataInput;
      // else this.menus = res.menu
      this.isDefaultNetwork = this.pathdata.isDefaultNetwork === 'true' ? true : false;
      if (localStorage.getItem("userId") === this.pathdata.networkOwnerId) {
        this.networkOwnerFlag = true;
        if (this.menus == "member") {
          this.membermenuflag = false;
        }
        else if (this.menus == "members") {
          this.membermenuflag = false;
        } else if (this.menus == "inviteSent") {
          this.membermenuflag = false;
        }
      }
      this.api.query("network/invite/sent/" + this.pathdata.networkId).subscribe((res) => {
        this.commonVariables.pendingCount = res.data.SentRequests.length;
        this.SearchData.setCommonVariables(this.commonVariables);
      }, err => {
        this.util.stopLoader();
      });

    });



  }

  isChildActive(parentRoute: string): boolean {
    return this.currentRoute.startsWith(parentRoute);
  }


  menuclick(name) {
    let values: any = {};
    let x = JSON.parse(JSON.stringify(this.pathdata));
    values = x
    this.router.navigate(["/networkPage/" + name], { queryParams: values });
  }
}
